import * as React from 'react'

import styles from './Tabs.module.scss'

type Props = {
	children: React.ReactElement | React.ReactElement[]
	className?: string
}

const Tabs = ({ children, className }: Props): JSX.Element => {
	return <div className={`${styles.tabs} ${className || ''}`}>{children}</div>
}

export default Tabs
